module.exports = __webpack_public_path__ + "static/media/react-icon.05a3e30f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/react-icon.svg
// module id = 102
// module chunks = 0